import React, {useEffect, useRef, useState} from 'react';
import {exportarFondosPendientes, informeFondo, traerFecha} from "../../../../api/informes.service";
import {UsePermissions} from "../../../../hooks/usePermissions";
import {UseLoader} from "../../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerTable} from "../../../Containers/ContainerTable";
import {exportExcel, formatFecha} from "../../../../shared/utils/utils";
import {useReactToPrint} from "react-to-print";
import {FondoPrintAll} from "../fondos/FondoPrintAll";

export const InformefondosTotal = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const [fechaPago, setFechaPago] = useState([]);
    const toast = useRef(null);
    const componentRef = useRef(null);
    const [selectedFecha, setSelectedFecha] = useState({
        fecha_pago: "",
    });
    const [FilteredFecha, setFilteredFecha] = useState(null);
    const [dataFondo, setdataFondo] = useState([]);
    useEffect(() => {
        handleLoad(true)
        traerFecha().then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setFechaPago([])
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
            setFechaPago(r.data)

        }).catch(() => handleLoad(false))
        return () => {

        };
    }, []);

    const handlePrint = useReactToPrint({
        documentTitle: "Pago Compensación TOA",
        content: () => componentRef.current,
        onBeforePrint: () => handleLoad(true),
        onAfterPrint: () => handleLoad(false),
    });

    const searchFechaPago = (event) => {
        setTimeout(() => {
            let _filteredFecha;
            if (!event.query.trim().length) {
                _filteredFecha = [...fechaPago];
            } else {
                _filteredFecha = fechaPago.filter((fecha) => {
                    return fecha.fecha_pago.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredFecha(_filteredFecha);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.fecha_pago.split('T')[0]}</div>
            </div>
        );
    }

    const onSelect = (e) => {

        if (e.fecha_pago !== undefined) {
            const formatoFecha = e.fecha_pago.split('T')[0];
            setSelectedFecha({...setSelectedFecha, fecha_pago: formatoFecha})
        } else {
            setSelectedFecha({...setSelectedFecha, fecha_pago: ''})
        }

    }

    const buscarPagos = () => {
        if (selectedFecha.fecha_pago === "") {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)

        const payLoad = {
            fecha: selectedFecha.fecha_pago
        }
        /** informes info */
        informeFondo(payLoad).then(r => {
            handleLoad(false)

            if (r.estado !== 200) {
                setdataFondo([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }


            if (r.data.length > 0) {
                setdataFondo(r.data);
            }

        }).catch(r => handleLoad(false))

    }

    const handleXport = async () => {
        handleLoad(true)

        const response = await exportarFondosPendientes();
        handleLoad(false)
        if (response.estado !== 200) {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
            return;
        }

        exportExcel(response.data, 'Fondos_pendientes_');
    }
    return (
        <>
            <Toast ref={toast}/>
            <div className="container-relative">
                <ContainerTable>
                    <div className="px-2">
                        <div className=" flex flex-wrap items-center  p-4 primary-color">
                            {permisos.consultar === 1 && fechaPago.length > 0 ?
                                <div className=" mt-2 relative lg:w-4/12 px-4">
                                    <AutoComplete value={selectedFecha} suggestions={FilteredFecha}
                                                  style={{"width": "100%"}}
                                                  completeMethod={searchFechaPago}
                                                  placeholder="Buscador de fecha pago"
                                                  size="30"
                                                  field="fecha_pago" dropdown itemTemplate={itemTemplate}
                                                  onChange={(e) => onSelect(e.value)}/>
                                </div>
                                : ""}
                            <div className=" mt-2 relative lg:w-2/12 px-4">
                                <button
                                    className="warning-color-btn btn w-full"
                                    type="button"
                                    onClick={buscarPagos}
                                >
                                    Buscar
                                </button>
                            </div>
                            {dataFondo.length > 0 && <div className=" mt-2 relative lg:w-3/12 px-4">
                                <button
                                    className="secundary-color-btn btn w-full"
                                    type="button"
                                    onClick={handlePrint}
                                >
                                    Imprimir
                                </button>
                            </div>}
                            <div className=" mt-2 relative lg:w-3/12 px-4">
                                <button
                                    className="secundary-color-btn btn w-full"
                                    type="button"
                                    onClick={handleXport}
                                >
                                    Exportar fondos pendientes
                                </button>
                            </div>
                        </div>

                    </div>
                    {dataFondo.length > 0 && <FondoPrintAll
                        ref={componentRef}
                        datafondo={dataFondo}
                    />}
                </ContainerTable>
            </div>
        </>
    );
};


